// src/components/Button.tsx
import React from 'react';
import { theme } from '../styles/theme';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLElement> {
  /** ボタン色をテーマのkeyか、カスタムカラーコードで指定 */
  bgColor?: string;
  /** 文字色をテーマのkeyか、カスタムカラーコードで指定 */
  textColor?: string;
  /** 角丸にするかどうか */
  rounded?: boolean;
  /** 幅(pxや%)やheightを指定可能に (例: '200px', '100%', etc.) */
  width?: string;
  height?: string;
  border?: string;
  /** コンポーネントとしてレンダリングする要素（例: "button" や "a" など） */
  as?: React.ElementType;
}

/**
 * Button - 汎用ボタンコンポーネント
 * - テーマからのデフォルト値や props で渡された値を元にスタイルを作成
 */
const Button: React.FC<ButtonProps> = ({
  children,
  bgColor,
  textColor,
  rounded,
  width,
  height,
  border,
  as,
  className,
  ...rest
}) => {
  // テーマに定義されている色が存在すればそちらを優先し、なければそのまま使用
  const computedBgColor =
    bgColor && (theme.colors as any)[bgColor]
      ? (theme.colors as any)[bgColor]
      : bgColor || theme.colors.primary;
  const computedTextColor =
    textColor && (theme.colors as any)[textColor]
      ? (theme.colors as any)[textColor]
      : textColor || theme.colors.white;

  // インラインスタイルの生成
  const style: React.CSSProperties = {
    backgroundColor: rest.disabled ? undefined : computedBgColor,
    color: computedTextColor,
    border: border || 'none',
    cursor: 'pointer',
    fontSize: '1rem',
    padding: '0.6rem 1.2rem',
    fontWeight: 600,
    borderRadius: rounded ? theme.borderRadius.md : theme.borderRadius.none,
    width: width || 'auto',
    height: height || 'auto',
  };

  // as propで渡されたコンポーネント、なければbuttonをレンダリング
  const Component: React.ElementType = as || 'button';

  return (
    <Component style={style} className={className} {...rest}>
      {children}
    </Component>
  );
};

export default Button;
